import React from "react";

import { Container } from "@components/Layout/Container";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Statement.styled";

export const Statement = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Container>
      <Styled.Heading>{translate("statement_heading")}</Styled.Heading>
    </Container>
  );
};
